import UIComponent from "../../common/UIComponent";
import "./index.css";
import { debounce } from "../../common/Utils";
export default class VolumeBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.nowVolume = 100;
    this.init();

    this.interfaces.on(VhallPlayer.MUTE_CHANGE, (e) => {
      if (this.interfaces.getmute()) {
        this.volumeBtn.classList.add("mute");
      } else {
        this.volumeBtn.classList.remove("mute");
      }
    });
  }

  init() {
    this.volumeComponent = document.createElement("div");
    this.volumeComponent.setAttribute("class", "vhallPlayer-volume-component");

    this.volumeBtn = document.createElement("span");
    this.volumeBtn.setAttribute("class", "vhallPlayer-volume-btn");
    this.volumeBtn.onclick = this.handleBtnClick.bind(this);
    if(this.interfaces.vhallplayer.player.video.muted == true) {
      this.volumeBtn.classList.add("mute");
    }

    this.volumeComponent.appendChild(this.volumeBtn);
    this.insertElement(this.elementId, this.volumeComponent);
  }

  handleBtnClick() {
    if (!this.interfaces.getmute()) {
      this.interfaces.setMute(true)
    } else {
      this.interfaces.setMute(false)
    }
  }

}